// src/pages/DashboardEmpleado.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Box, Toolbar, Paper, Typography, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { percepciones, deducciones } from "../services/api";

export default function DashboardEmpleado() {
  const [tab, setTab] = useState("percepciones");
  const [per, setPer] = useState([]);
  const [ded, setDed] = useState([]);
  const empleadoId = localStorage.getItem("empleado_id"); // REQUIERE que el backend lo devuelva

  const load = async () => {
    try {
      const [p, d] = await Promise.all([percepciones.list(), deducciones.list()]);
      // Si tenemos empleadoId, filtramos cliente (ideal: añadir filtro en la API)
      const pData = p.data || [];
      const dData = d.data || [];
      setPer(empleadoId ? pData.filter(x => String(x.empleado_id) === String(empleadoId)) : pData);
      setDed(empleadoId ? dData.filter(x => String(x.empleado_id) === String(empleadoId)) : dData);
    } catch {
      alert("Error cargando datos");
    }
  };

  useEffect(() => { load(); }, []);

  const totalPer = useMemo(() => per.reduce((a, b) => a + Number(b.monto || 0), 0), [per]);
  const totalDed = useMemo(() => ded.reduce((a, b) => a + Number(b.monto || 0), 0), [ded]);
  const neto = totalPer - totalDed;

  return (
    <Box sx={{ display: "flex" }}>
      <Navbar />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Typography variant="h5" mb={2}>Mi Panel</Typography>

        <Paper sx={{ mb: 2 }}>
          <Tabs value={tab} onChange={(e, v) => setTab(v)}>
            <Tab label="Percepciones" value="percepciones" />
            <Tab label="Deducciones" value="deducciones" />
          </Tabs>
        </Paper>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle1">Resumen</Typography>
          <Typography>Total percepciones: ${totalPer.toFixed(2)}</Typography>
          <Typography>Total deducciones: ${totalDed.toFixed(2)}</Typography>
          <Typography><b>Neto estimado: ${neto.toFixed(2)}</b></Typography>
        </Paper>

        {tab === "percepciones" && (
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" mb={1}>Mis percepciones ({per.length})</Typography>
            <Table size="small">
              <TableHead><TableRow><TableCell>Tipo</TableCell><TableCell>Monto</TableCell><TableCell>Fecha</TableCell><TableCell>Descripción</TableCell></TableRow></TableHead>
              <TableBody>
                {per.map((r) => (
                  <TableRow key={r.id}>
                    <TableCell>{r.tipo}</TableCell>
                    <TableCell>${Number(r.monto || 0).toFixed(2)}</TableCell>
                    <TableCell>{r.fecha}</TableCell>
                    <TableCell>{r.descripcion}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}

        {tab === "deducciones" && (
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" mb={1}>Mis deducciones ({ded.length})</Typography>
            <Table size="small">
              <TableHead><TableRow><TableCell>Tipo</TableCell><TableCell>Monto</TableCell><TableCell>Fecha</TableCell><TableCell>Descripción</TableCell></TableRow></TableHead>
              <TableBody>
                {ded.map((r) => (
                  <TableRow key={r.id}>
                    <TableCell>{r.tipo}</TableCell>
                    <TableCell>${Number(r.monto || 0).toFixed(2)}</TableCell>
                    <TableCell>{r.fecha}</TableCell>
                    <TableCell>{r.descripcion}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}
      </Box>
    </Box>
  );
}
